/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const DashboardGauge: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0)">
  <path d="M14.422 9.62491C13.989 9.51491 13.506 9.73091 13.345 10.1099L11.267 15.0059C11.261 15.0059 11.255 15.0039 11.249 15.0039C10.007 15.0039 8.999 16.0099 8.999 17.2539C8.999 18.4959 10.007 19.5019 11.249 19.5019C12.491 19.5019 13.499 18.4959 13.499 17.2539C13.499 16.5949 13.211 16.0079 12.76 15.5969L14.92 10.5069C15.079 10.1289 14.856 9.73491 14.422 9.62491ZM11.25 18.0059C10.835 18.0059 10.5 17.6699 10.5 17.2559C10.5 16.8419 10.835 16.5059 11.25 16.5059C11.663 16.5059 12 16.8419 12 17.2559C12 17.6699 11.664 18.0059 11.25 18.0059ZM12 0.00390625C5.373 0.00390625 0 5.37491 0 12.0039C0 18.6329 5.373 24.0019 12 24.0019C18.625 24.0019 24 18.6319 24 12.0039C24 5.37591 18.627 0.00390625 12 0.00390625V0.00390625ZM12 22.5039C6.2 22.5039 1.5 17.8029 1.5 12.0039C1.5 6.20491 6.201 1.50391 12 1.50391C17.797 1.50391 22.5 6.20491 22.5 12.0039C22.5 17.8029 17.797 22.5039 12 22.5039ZM12 4.50391C7.857 4.50391 4.5 7.86091 4.5 12.0039H6C6 8.69091 8.687 6.00391 12 6.00391C15.312 6.00391 18 8.69091 18 12.0039H19.5C19.5 7.86091 16.143 4.50391 12 4.50391Z" />
</g>

      <defs>
  <clipPath id="clip0">
    <rect width={24} height={24} />
  </clipPath>
</defs>

    </StyledIconBase>
  )
})

DashboardGauge.displayName = 'DashboardGauge'

export const DashboardGaugeDimensions = {height: 24, width: 24}
